import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEntityTypeState, IEntityTypeDropdown } from "../../../types/entityTypes/entityTypeInterfaces";

export const initialState: IEntityTypeState = {
  entityTypeDropdown: []
};

export const entityTypeSlice = createSlice({
  name: 'entityType',
  initialState,
  reducers: {
    loadingEntityTypeDropdown: (state, action: PayloadAction<IEntityTypeDropdown[]>) => {
      state.entityTypeDropdown = action.payload;
    },
  }
});

export const { loadingEntityTypeDropdown } = entityTypeSlice.actions;

export default entityTypeSlice.reducer;
